var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModavest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 345 345",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eb0145;}.cls-2{fill:#9b042a;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 345,
    height: 345,
    rx: 53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.81,147.34l-32.55-32.53a1.85,1.85,0,0,0-3,1.37v44.45a1.81,1.81,0,0,0,1.8,1.81,1.72,1.72,0,0,0,1.18-.44l9-7.86,7.36,17.18a1.22,1.22,0,0,0,.65.65,1.42,1.42,0,0,0,.45.08,1.1,1.1,0,0,0,.47-.1l7.74-3.31a1.2,1.2,0,0,0,.63-1.58l-7.12-16.64h12.07a1.79,1.79,0,0,0,1.8-1.8,2,2,0,0,0-.51-1.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M203.81,141.44l-32.55-32.53a1.85,1.85,0,0,0-3,1.37v44.45a1.8,1.8,0,0,0,1.8,1.81,1.72,1.72,0,0,0,1.18-.44l9-7.85,7.36,17.18a1.16,1.16,0,0,0,1.1.72,1.1,1.1,0,0,0,.47-.1l7.74-3.31a1.2,1.2,0,0,0,.63-1.58l-7.12-16.64h12.07a1.79,1.79,0,0,0,1.8-1.8,2,2,0,0,0-.51-1.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M266,119.12c-4.49,0-9.23,3.64-9.23,8.14v20.16c0,39.54-29.81,71.71-69.29,71.71s-69.29-32.08-69.29-71.5V93a6.74,6.74,0,0,0-2.33-4.77,10.33,10.33,0,0,0-17.39-6.77L72.88,105.19c-4.2,3.91-4.06,12.32-.15,16.53a10.4,10.4,0,0,0,14.69.53l10-10.13v35.51c0,48.41,40.45,87.8,88.92,87.8s88.93-39.48,88.93-88V127.26C275.24,122.76,270.49,119.12,266,119.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.24,256.59a12.18,12.18,0,1,0-12.18,12.18,12.17,12.17,0,0,0,12.18-12.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M224.67,256.59a12.18,12.18,0,1,0-12.18,12.18,12.17,12.17,0,0,0,12.18-12.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M169.46,250.44a12.18,12.18,0,1,0-12.17,12.18,12.17,12.17,0,0,0,12.17-12.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M228.89,250.44a12.18,12.18,0,1,0-12.17,12.18,12.17,12.17,0,0,0,12.17-12.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M266,110.54c-4.49,0-9.23,3.65-9.23,8.15v20.16c0,39.54-29.81,71.71-69.29,71.71s-69.29-32.08-69.29-71.51V84.38c0-4.5-5.9-8.15-10.39-8.15-.26,0-.51,0-.77,0a10.31,10.31,0,0,0-5.94,2.21l-.16.13c-.28.2-.54.41-.8.63L73.71,100.16a10.4,10.4,0,0,0,12.91,16.3l10.77-8.54v31.13c0,48.42,40.45,87.8,88.92,87.8s88.93-39.48,88.93-88V118.69C275.24,114.19,270.49,110.54,266,110.54Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModavest);
export default __webpack_public_path__ + "static/media/modavest.8f20c5cf.svg";
export { ForwardRef as ReactComponent };